/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_New_Classification_TemplateInputs */

const en_page_title_new_classification_template = /** @type {(inputs: Page_Title_New_Classification_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New classification template`)
};

const nl_page_title_new_classification_template = /** @type {(inputs: Page_Title_New_Classification_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw classificatiesjabloon`)
};

/**
* | output |
* | --- |
* | "New classification template" |
*
* @param {Page_Title_New_Classification_TemplateInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_new_classification_template = /** @type {((inputs?: Page_Title_New_Classification_TemplateInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_New_Classification_TemplateInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_new_classification_template(inputs)
	return en_page_title_new_classification_template(inputs)
});